// extracted by mini-css-extract-plugin
export default {"container":"YD-z","modal":"ZD-z","dimensions":"_D-z","brandName":"aE-z","productName":"bE-z","labelValue":"cE-z","recipientEmail":"dE-z","recommendedFit":"eE-z","hiddenField":"fE-z"};